import Routers from "router/Routers";

const App = (): JSX.Element => {
  return <Routers />;
};

export default App;
